import React from 'react';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis,} from 'recharts';

export default function InvestmentsChart({ items }) {
  const indexData = items[0]?.index_data || [];
  const benchmarkData = items[0]?.benchmark_data || [];
  const formattedIndexData = indexData.map(item => ({
    date: new Date(item.date),
    Index: item.price,
  }))

  const formattedBenchmarkData = benchmarkData.map(item => ({
    date: new Date(item.date),
    Benchmark: parseFloat(item.price),
  }))

  const combinedData = [...formattedIndexData, ...formattedBenchmarkData]
    .sort((a, b) => a.date - b.date)
    .reduce((acc, cur) => {
      let last = acc[acc.length - 1];
      if (!last || last.date.getTime() !== cur.date.getTime()) {
        acc.push(cur)
      } else {
        if (cur.Index) last.Index = cur.Index
        if (cur.Benchmark) last.Benchmark = cur.Benchmark
      }
      return acc
    }, [])
 // Find the min and max values of the data
  const indexPrices = combinedData.map(item => item.Index).filter(price => typeof price === 'number');
  const benchmarkPrices = combinedData.map(item => item.Benchmark).filter(price => typeof price === 'number');

  const minPrice = Math.min(...indexPrices.concat(benchmarkPrices));
  const maxPrice = Math.max(...indexPrices.concat(benchmarkPrices));

  // Define custom domain for Y-axis
  const domain = [Math.floor(minPrice / 10) * 10, Math.ceil(maxPrice / 10) * 10];
  return (
    <div className='index-investments-chart-wrapper' dir='ltr'>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={combinedData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            tickFormatter={(tickItem) => {
              const date = new Date(tickItem);
              return `${date.getFullYear()}`;
            }}
          />
          <YAxis domain={domain} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Index" stroke="#33469A" dot={{ r: 1 }} />
          {benchmarkData.length > 0 &&
            <Line type="monotone" dataKey="Benchmark" stroke="#FF0000" dot={{ r: 1 }} />
          }

        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
